@if (open) {
  <button class="scrim" type="button" aria-label="Close menu" (click)="close()"></button>
  <nav class="drawer">
    <div class="drawer-user">
      @if (auth.user()?.profilePictureUrl) {
        <img class="avatar avatar-row" [src]="auth.user()?.profilePictureUrl" alt="" (error)="hideImage($event)" />
      }
      <span>Signed in as {{ auth.user()?.displayName }}</span>
    </div>
    <a routerLink="/leagues" (click)="close()">My leagues</a>
    @if (organizer) {
      <div class="drawer-label">Organizer</div>
      <div class="drawer-split">
        <a routerLink="/admin/leagues" (click)="close()">Admin</a>
        <a class="drawer-pop" href="/admin/leagues" target="_blank" rel="noopener" aria-label="Open Admin in a new tab" (click)="close()">
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M14 5h5v5M19 5l-8 8" />
            <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M10 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4" />
          </svg>
        </a>
      </div>
    }
    <a routerLink="/profile" (click)="close()">Profile</a>
    <button class="drawer-logout" type="button" (click)="logout()">Log out</button>
  </nav>
}
